module.exports = __webpack_public_path__ + "img/small-mob-1.ad1bc4da.webp";